import React from 'react';
import PropTypes from 'prop-types';
import css from './CwShell.scss';
import CwShellLeftNav from '../cwshellleftnav/CwShellLeftNav';
import {CwShellLeftNavExpand} from '../cwshellleftnav/constants';

class CwShell extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      leftNavActiveButton: null,
      leftNavActiveLink: null
    };

    this.renderChildren = this.renderChildren.bind(this);
  };

  setLeftNavActiveButton = (id) => {
    this.setState({
      leftNavActiveButton: this.state.leftNavActiveButton === id ? null : id
    });
  };

  setLeftNavActiveLink = (id) => {
    this.setState({
      leftNavActiveLink: this.state.leftNavActiveLink === id ? null : id
    });
  };

  renderChildren = () => {
    return React.Children.map(this.props.children, child => {
      switch(child.type) {

        case CwShellLeftNav:
          return React.cloneElement(child, {
            expand: this.props.leftNavExpand,
            activeButton: this.state.leftNavActiveButton,
            activeLink: this.state.leftNavActiveLink,
            setActiveButton: this.setLeftNavActiveButton,
            setActiveLink: this.setLeftNavActiveLink
          });

        default: return child;
      }
    });
  };

  render() {

    // add left padding based on leftLavExpand value
    let paddingLeft = 0;
    switch (this.props.leftNavExpand) {
      case CwShellLeftNavExpand.COLLAPSED: paddingLeft = 32; break;
      case CwShellLeftNavExpand.DEFAULT: paddingLeft = 88; break;
      case CwShellLeftNavExpand.FAT: paddingLeft = 192; break;
      default: paddingLeft = 0;
    }

    return (
      <div className={css.cwShell} style={this.props.style}>
        <div style={{paddingLeft: paddingLeft, paddingTop: 48}}>
          {this.renderChildren()}
        </div>
      </div>
    );
  };
};

CwShell.propTypes = {
  children: PropTypes.any,
  /**
   *  Determines amount of padding and expansion style of left navigation menu
   **/
  leftNavExpand: PropTypes.oneOf([
    CwShellLeftNavExpand.COLLAPSED,
    CwShellLeftNavExpand.DEFAULT,
    CwShellLeftNavExpand.FAT
  ]),
  /**
   * Allows custom styling
   */
  style: PropTypes.object
};

CwShell.defaultProps = {
  style: {}
};

export default CwShell;


// WEBPACK FOOTER //
// ./src/components/cwshell/CwShell.jsx